/** The column definition for the snapshots table with the field property typed */

/** All available column fields for the snapshots table */
export const SNAPSHOTS_TABLE_COLUMNS = ["name", "accessLevel", "created", "options"];

/** The column fields that can be used in the snapshots table */

/** Sortable column fields for the snapshots table */
export const SNAPSHOTS_SORT_BY = ["name_ascending", "name_descending", "created_ascending", "created_descending", "accessLevel_ascending", "accessLevel_descending"];

/** All possible snapshots sort by values */

/** Available snapshots sort fields - derived from SNAPSHOTS_SORTABLE_FIELDS */